export function StatCard({ label, value, sub, icon: Icon, accent = "primary", testid, onClick }) {
  const accentClass =
    accent === "gold" ? "text-gold bg-gold/15" : accent === "info" ? "text-blue-400 bg-blue-400/15" : "text-primary bg-primary/15";
  return (
    <div onClick={onClick} className={`card-surface rounded-xl p-5 stat-glow ${onClick ? "cursor-pointer" : ""}`} data-testid={testid}>
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs text-muted-foreground font-medium">{label}</div>
          <div className="mt-2 font-display text-2xl font-bold num">{value}</div>
          {sub && <div className="mt-1 text-xs text-muted-foreground">{sub}</div>}
        </div>
        {Icon && (
          <div className={`h-10 w-10 rounded-lg flex items-center justify-center ${accentClass}`}>
            <Icon className="h-5 w-5" />
          </div>
        )}
      </div>
    </div>
  );
}

export function StarRating({ value, size = 16, onChange }) {
  return (
    <span className="inline-flex items-center gap-0.5" data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          disabled={!onChange}
          onClick={() => onChange && onChange(i)}
          data-testid={onChange ? `star-${i}` : undefined}
          className={onChange ? "cursor-pointer" : "cursor-default"}
          style={{ lineHeight: 0 }}
        >
          <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill={i <= value ? "hsl(32 95% 50%)" : "none"}
            stroke={i <= value ? "hsl(32 95% 50%)" : "hsl(215 20% 40%)"}
            strokeWidth="2"
          >
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
          </svg>
        </button>
      ))}
    </span>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-6 flex-wrap">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}
